class AnimateTable extends window.BAO.CustomElement() {
  constructor () {
    super()

    if (!this.querySelector('table')) return

    this.querySelectorAll('th, td').forEach(currentTableTd => {
      currentTableTd.addEventListener('mouseenter', () => {
        currentTableTd
          .closest('table')
          .querySelectorAll('tr')
          .forEach(tableTr => {
            tableTr.querySelectorAll('th, td').forEach((tableTd, r) => {
              r === currentTableTd.cellIndex
                ? tableTd.classList.add('rte-RichText_ColumnHighlight')
                : tableTd.classList.remove('rte-RichText_ColumnHighlight')
            })
          })
      })
    })

    this.addEventListener('mouseleave', () => {
      this.querySelectorAll('th, td').forEach(tableTd => {
        return tableTd.classList.remove('rte-RichText_ColumnHighlight')
      })
    })
  }

  setupListeners () {
    super.setupListeners()
  }
}

if (!customElements.get('animate-table')) {
  customElements.define('animate-table', AnimateTable)
}
